import { render, staticRenderFns } from "./AdditionalDetail.vue?vue&type=template&id=a7b32598&scoped=true&"
import script from "./AdditionalDetail.vue?vue&type=script&lang=js&"
export * from "./AdditionalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b32598",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7b32598')) {
      api.createRecord('a7b32598', component.options)
    } else {
      api.reload('a7b32598', component.options)
    }
    module.hot.accept("./AdditionalDetail.vue?vue&type=template&id=a7b32598&scoped=true&", function () {
      api.rerender('a7b32598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/AdditionalDetail.vue"
export default component.exports